import React, {useState, useEffect} from "react";
import { mapOptions } from "./MapConfig";
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
    width: '100%',
    height: '400px',
    border: '1px solid #242a2e72',
    borderRadius: '10px'
};

const MapComponent = (props) => {

    const defaultCoordinates = { lat: 28.457523, lng: 77.026344 }

    const [coordinates, setCoordinates] = useState(defaultCoordinates);
    const [infoWindowOpen, setInfoWindowOpen] = useState(false);
    const [markerAddress, setMarkerAddress] = useState('')

    const { isLoaded } = useJsApiLoader({
        id: mapOptions.GoogleMapsAPI,
        googleMapsApiKey: mapOptions.GoogleMapsAPI
    })

    const getAddressFromCoordinates = (position) => {
        fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.lat},${position.lng}&key=${mapOptions.GoogleMapsAPI}`)
        .then(res => res.json())
        .then(data => {
            if(data.results && data.results.length > 0) {
                const formattedAddress = data.results[0].formatted_address;
                setMarkerAddress(formattedAddress)
            } else {
                console.error("No address is found on the coordinates")
            }
        })
        .catch(err => console.error("Error found in address: ", err))
    }

    const handleMarkerDragEnd = (e) => {
        const newCoordinates = { lat: e.latLng.lat(), lng: e.latLng.lng() }
        setCoordinates(newCoordinates);
        getAddressFromCoordinates(newCoordinates)
    };

    useEffect(() => {
        if(Object.keys(props.locationCoordinates).length !== 0) {
            setCoordinates(props.locationCoordinates)
            getAddressFromCoordinates(props.locationCoordinates)
        } else {
            setCoordinates(defaultCoordinates)
            getAddressFromCoordinates(defaultCoordinates);
        }
    },[props.locationCoordinates])

    return isLoaded ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={coordinates}
          zoom={10}
        >
          
          <Marker
            position={coordinates}
            draggable={true}
            onDragEnd={handleMarkerDragEnd}
            onClick={() => setInfoWindowOpen(true)}
          />

          {infoWindowOpen && (
            <InfoWindow
              position={{ lat: coordinates.lat + 0.05, lng: coordinates.lng }}
              onCloseClick={() => setInfoWindowOpen(false)}
            >
                <div>
                    <p>{markerAddress}</p>
                </div>
            </InfoWindow>
          )}

        </GoogleMap>
    ) : <></>

}

export default MapComponent;